<template>
  <div
      class="w-ful h-fit flex flex-col px-[20px] bg-white border border-grays-400 rounded"
  >
    <button
        class="flex flex-row-reverse items-center justify-between gap-[8px] py-[16px]"
        @click="triggerDisclosure"
    >
      <div
          class="group w-7 h-7 rounded-md flex flex-none justify-center items-center bg-primary-400 hover:bg-primary-100 focus:bg-purple_semantic active:bg-purple_semantic disabled:bg-grays-400"
      >
        <span
            :class="[
            'material-symbols-rounded text-xl text-primary-700 group-disabled:text-grays-600',
            showDiscolsure ? 'rotate-180' : '',
          ]"
        >
          expand_more
        </span>
      </div>
      <p class="text-lg text-primary-700 font-medium text-right">{{ disclosure.title }}</p>
    </button>
    <!-- disclosre open content -->
    <div v-if="showDiscolsure" class="pb-[27px] pl-[100px]">
      <p
          class="text-grays-700 font-regular"
      >
        {{ disclosure.answerPart1 }}
        <default-router-link v-if="disclosure.linkText1 && !disclosure.action" :to="disclosure.linkRoute1"
                             class="text-[#3F238B] font-bold underline" route="">
          {{ disclosure.linkText1 }}
        </default-router-link>
        <span v-else-if="disclosure.action"
              class="text-primary-700 font-bold underline hover:text-primary-800 focus:text-primary-900 active:text-primary-900 disabled:text-grays-600 cursor-pointer"
              @click="handleActions">{{
            disclosure.action === 'openDebtModal' && debts.length ? disclosure.linkText1 : disclosure.action !== 'openDebtModal' ? disclosure.linkText1 : ''
          }}</span>
        {{
          disclosure.action === 'openDebtModal' && !debts.length ? disclosure.linkText1 + ' ' + disclosure.answerPart2 : disclosure.answerPart2
        }}
        <default-router-link v-if="disclosure.linkText2" :to="disclosure.linkRoute2"
                             class="text-[#3F238B] font-bold underline" route="">
          {{
            disclosure.linkText2
          }}
        </default-router-link>
        {{ disclosure.answerPart3 }}
      </p>
    </div>
  </div>
</template>

<script>
import DefaultRouterLink from "@/components/Global/DefaultRouterLink.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "faq-disclosure",
  props: {
    disclosure: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDiscolsure: false,
    };
  },
  components: {DefaultRouterLink},
  methods: {
    handleActions() {
      switch (this.disclosure.action) {
        case 'openDebtModal': {
          this.toggleDebtsModal()
          break;
        }
        case 'goToNotifications': {
          this.$router.push("/profile");
          setTimeout(() => {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            });
          }, 100);
          break;
        }
        case 'goToChangeStation': {
          this.$router.push("/profile");
          setTimeout(() => {
            window.scrollTo({
              top: 800,
              behavior: "smooth",
            });
          }, 100);
          break;
        }
      }
    },
    triggerDisclosure() {
      this.showDiscolsure = !this.showDiscolsure;
    },
    ...mapActions({
      toggleDebtsModal: "debtsModule/toggleIsModalVisible",
    })
  },
  computed: {
    ...mapGetters({
      debts: "debtsModule/getDebts",
    }),
  }
};
</script>

<style>
</style>